<template lang="pug">
.loading(v-if="show")
  .bouncywrap
    .dotcon.dc1
      .dot
    .dotcon.dc2
      .dot
    .dotcon.dc3
      .dot
</template>

<script>

export default {
  name: 'loading',
  props: ['show'],
  data () {
    return {
    }
  },
  computed: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import('../assets/styles/_constants.styl')
.loading
  height 55px
  text-align center
.bouncywrap
  width 55px
  left 50%
  //margin 0 auto
  position relative
  .dc1
    -webkit-animation bouncy1 1.5s infinite
    left -40px
  .dc2
    -webkit-animation bouncy2 1.5s infinite
    animation bouncy2 1.5s infinite
    left: 0
  .dc3
    -webkit-animation bouncy3 1.5s infinite
    animation bouncy3 1.5s infinite
    left 40px
  .dotcon
    display inline-block
    width 55px
    position absolute
    .dot
      height 15px
      width 15px
      border-radius 50%
      background #fff

@-webkit-keyframes bouncy1
  0%
    -webkit-transform translate(0px,0px) rotate(0deg)
  50%
    -webkit-transform translate(0px,0px) rotate(180deg)
  100%
    -webkit-transform translate(40px,0px) rotate(-180deg)

@keyframes bouncy1
  0%
    -webkit-transform translate(0px,0px) rotate(0deg)
  50%
    -webkit-transform translate(0px,0px) rotate(180deg)
  100%
    -webkit-transform translate(40px,0px) rotate(-180deg)

@-webkit-keyframes bouncy2
  0%
    -webkit-transform translateX(0px)
  50%
    -webkit-transform translateX(-40px)
  100%
    -webkit-transform translateX(-40px)

@keyframes bouncy2
  0%
    transform translateX(0px)
  50%
    transform translateX(-40px)
  100%
    transform translateX(-40px)

@-webkit-keyframes bouncy3
  0%
    -webkit-transform translateX(0px)
  50%
    -webkit-transform translateX(0px)
  100%
    -webkit-transform translateX(-40px)

@keyframes bouncy3
  0%
    transform translateX(0px)
  50%
    transform translateX(0px)
  100%
    transform translateX(-40px)

</style>



// WEBPACK FOOTER //
// Loading.vue?5a9267f8